// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from 'axios';
import Vue from 'vue';
import App from './App';
import router from './router';
import BootstrapVue from 'bootstrap-vue';
import store from './store';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue2Filters from 'vue2-filters';
import Toaster from 'v-toaster';
import moment from 'moment-timezone';
import vue_moment from 'vue-moment';
import money from 'v-money';
import 'v-toaster/dist/v-toaster.css';

moment.tz.setDefault('Greenwich');

Vue.use(Toaster, { timeout: 3000 });
Vue.use(money, { precision: 2 });
library.add(fas);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(Vue2Filters);
Vue.use(vue_moment, { moment });
Vue.config.productionTip = false;
const axiosConfig = {
  baseURL: process.env.API_URL || 'http://localhost:8010/private',
  timeout: 120000,
};
Vue.prototype.$axios = axios.create(axiosConfig);
Vue.prototype.$axios.interceptors.request.use(config => {
  window.getApp.$emit('APP_LOADING', true);
  // Do something before request is sent
  config.headers.Authorization = 123456;
  config.headers.Token = store.getters.token;
  config.headers.CodEmp = store.getters.user ? store.getters.user.CodEmp : null;

  return config;
}, error => {
  // Do something with request error
  return Promise.reject(error);
});
Vue.prototype.$axios.interceptors.response.use(response => {
  window.getApp.$emit('APP_LOADING', false);
  if (response.data) {
    if (response.data.token) {
      window.getApp.$emit('APP_UPDATE_TOKEN', response.data.token);
    }
    if (response.data.data) {
      response.data = response.data.data;
    }
  }
  return response;
}, error => {
  window.getApp.$emit('APP_LOADING', false);
  if (error && error.response && error.response.status) {
    if (error.response.status === 401) {
      window.getApp.$emit('APP_ACCESS_DENIED');
    } else if (error.response.status === 403) {
      window.getApp.$emit('APP_AUTH_FAILED');
    } else if (error.response.status === 500) {
      window.getApp.$emit('APP_BAD_REQUEST');
    } else {
      window.getApp.$emit('APP_CUSTOM_ERROR', error.response.data.error || error.message || 'Ocorreu um erro de conexão. Entre em contato com a fábrica!');
    }
  }
  else {
    window.getApp.$emit('APP_BAD_REQUEST');
  }
  return Promise.reject(error);
});

Vue.filter('cnpjCpf', function (dado) {
  let cnpjCpf = '';
  if (dado) {
    if (dado.length === 11) {
      cnpjCpf = `${dado.slice(0, 3)}.${dado.slice(3, 6)}.${dado.slice(6, 9)}-${dado.slice(9)}`;
    }
    else {
      cnpjCpf = `${dado.slice(0, 2)}.${dado.slice(2, 5)}.${dado.slice(5, 8)}/${dado.slice(8, 12)}-${dado.slice(12)}`;
    }
  }
  return cnpjCpf;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  components: { App },
  methods: {
    allowRegister () {
      return true;
      // return store.getters.user ? store.getters.user.CodRep === 15 || store.getters.user.CodRep === 193 || store.getters.user.CodRep === 200 : false;
    }
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js